window.SMTX.HomeHero = (function () {


  if ($('.home-hero').length < 1) {
    return false;
  }

  var sizeSwitch = 46.25;
  var switchHandle = $('.hero-lang-switch .handle');
  var switchArea = $('.hero-lang-switch');
  var _isDragging = false;
  var _langIndex = 0;
  var _langItems = window.SMTX.homeHeroLangItems;
  var _numOfLangItems = _langItems.length;
  var _defaultHeadline = $('[data-hh-default-headline]').data('hh-default-headline');
  var _isLeft = true;
  var _stepTimer = null;
  //log(_langItems);

  switchHandle.draggable({
    axis: 'x',
    containment: 'parent',
    stop: function () {
      var l = ( 100 * parseFloat($(this).position().left / parseFloat($(this).parent().outerWidth())) );
      $(this).css("left", l + "%");
      conditionMove(l);
    }, 

    drag: function () {
      var l = ( 100 * parseFloat($(this).position().left / parseFloat($(this).parent().outerWidth())) );
      if (l <= ( (100 - sizeSwitch ) / 2) && !_isLeft) {
        setDefaultLang();
      }else if(l > ( (100 - sizeSwitch ) / 2) && _isLeft){
        setNextLang();
      }
    }, 

    start: function () {
      _isDragging = true;
    },
  });

  switchArea.click(function () {
    conditionMoveSnap();
  });

  $('.hero-lang-switch').on('mouseenter', function(){
    //log('enter');
    stopTimer();
  });

  $('.hero-lang-switch').on('mouseleave', function(){
   // log('leave');
    startTimer();
  });

  function conditionMove(left) {
    if (left <= ( (100 - sizeSwitch ) / 2)) {
      switchHandle.stop().animate({
        left: 0
      }, 100, function(){
        _isDragging = false; 
      });
      setDefaultLang();
    }
    else {
      switchHandle.stop().animate({
        left: (100 - sizeSwitch) + '%'
      }, 100, function(){
        _isDragging = false; 
      });

      setNextLang();
    }
  }

  function conditionMoveSnap() {
    
    if(_isDragging === true){
      return false;
    }

    if (parseInt(switchHandle.css('left')) > sizeSwitch) {
      switchHandle.animate({
        left: 0
      }, 300);
      setDefaultLang();
    }
    else {
      switchHandle.animate({
        left: (100 - sizeSwitch) + '%'
      }, 300);
      setNextLang();
    }
    _isDragging = false;
  }

  function setDefaultLang(){
    
    $('[data-hh-default-headline]').html(_defaultHeadline);
    $('[data-hh-default-label]').removeClass('hide');
    $('[data-hh-translated-label]').addClass('hide');

    _isLeft = true;
  }

  function setNextLang(){

    var nextLangItem = getLangItemByIndex(_langIndex);
    //log(nextLangItem);
    $('[data-hh-translated-label]').text(nextLangItem.label);
    $('[data-hh-default-headline]').html(nextLangItem.headline);

    $('[data-hh-default-label]').addClass('hide');
    $('[data-hh-translated-label]').removeClass('hide');

    _isLeft = false;
    
    _langIndex++;

    if(_langIndex >= _numOfLangItems){
      _langIndex = 0;
    }

  }

  function getLangItemByIndex(i){
    return _langItems[i];
  }

  function onTimerTick(){
    conditionMoveSnap();
  }

  function startTimer(){
    if(!_stepTimer){
      _stepTimer = setInterval( function() {
        onTimerTick();
      }, 2000);
    }
  }

  function stopTimer(){
    if(_stepTimer){
      clearInterval(_stepTimer);
      _stepTimer = null;
    }
  }

  setTimeout(function(){
    startTimer();
  }, 500);

  return {

  };

})();
